import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../../../../src/Components/IconComponents/XCircleblack";
import {
    Editicon,
    Deleteicon,
    Viewicon
} from "../../../../Components/IconComponents";
import { toast, ToastContainer } from "react-toastify";
import Table from "../../../../Components/UiComponents/Table/Table";
import Moment from "react-moment";
import {
    SOPTableData,
    columnsForExport,
} from "../../../../JsonData/SOPConfig";
import { getData, putDataWithBody } from "../../../../Services/Services";
import {getSOPTasksDtlBySOPId } from "../../../../Services/EndPoints";
import { useDispatch } from "react-redux";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";


const SOPTaskTable = (props) => {
    const dispatch = useDispatch();
    const qs = require("qs");
    const [rowCount, setRowCount] = useState(0);
    const [SOPData, setSOPData] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const navigate = useNavigate();
     useEffect(() => {
         getSOPTaskDetailList();
     }, []);

 
    const addNewHandler = () => {
        navigate("/sop-management/create-sop");
    };
    const openSOPDataTable = async () => {
       setShow(true);
    };
    const getShortenedText=  (strLength,fulltext) => {
        let abbreviatedText = "";
        if(fulltext.length>strLength){
            abbreviatedText =  fulltext.substring(0,15)+"..."
        }
        else{
            abbreviatedText = fulltext;
        }
        return <span title={fulltext}>{abbreviatedText}</span>
    }
    const hideModal = () => {
        setShow(false);
    };
    const getSOPTaskDetailList =  async () => {
        var sopTaskList = await getData(getSOPTasksDtlBySOPId+props.sopInstanceData.id);
        setRowCount(sopTaskList.length);
        setSOPData(sopTaskList);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "Task Name",
                accessor: "task_name",
                disableSortBy: true
            },
           
             {
                Header: "Task Description",
                accessor: "description",
                disableSortBy: true
            },
            {
                Header: () => <span style={{ whiteSpace: "nowrap" }}>Assigned To</span>,
                disableSortBy: true,
                accessor: "role_name"
            },
            {
                Header: "Created On",
                disableSortBy: true,
                accessor: "created_on",
                Cell: (props) => {
                  return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
                },
            },
            {
                Header: "Last Updated On",
                disableSortBy: true,
                accessor: "updated_on",
                Cell: (props) => {
                  return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
                },
            }
        ],
        []
    );
    return (
        <div className="container-fluid px-3">
            {/* Scoped override — shared TableHeader's 1.3em padding leaves a
                large gap above/below its search row; tighten it just here so
                the title sits close to the table, matching the Resources table. */}
            <style>{`
                .sop-task-table-wrapper .iccc__table-header { padding: 0.3em 0.5em; }
                .sop-task-table-wrapper .iccc__table--container { margin-bottom: 0; }
                .sop-task-table-wrapper .float-start.m-2 { margin: 0.25rem !important; }
            `}</style>
            <span style={{color: "#17a3a0", fontSize: "17px", fontWeight: "700px"}}>SOP Tasks</span>
            <div className="datatable__container sop-task-table-wrapper">
                {SOPTableData && (
                    <Table
                        data={SOPData}
                        rowCount={rowCount}
                        columns={columns}
                        numberOfRows={7}
                        showExport={false}
                        showFilter={false}
                        showReset={false}
                        onExpand={false}
                        headerTableHeadStyle={{ background: "#1C4E72", color: "#FFFFFF" }}
                        tableStyle={{ border: "1px solid #000", padding: "0px", borderRadius: "8px", overflow: "hidden" }}
                    />
                )}
            </div>
        </div>
    );
};

export default SOPTaskTable;






// /planning/create - sop